import { useRuntimeConfigKey, type UseRuntimeConfig } from '@/injectionKeys';
import { buildOptimizedVideoUrl, type OptimizeVideoOptions } from '@/wabunka-src/common/utils/video/videoOptimizer';

/**
 * 最適化済み動画 URL を生成する関数を返すコンポーザブル。
 *
 * runtimeConfig の inject は **setup（コンポーネントの同期セットアップ）コンテキストでのみ解決できる**ため、
 * ここで一度だけ解決し、以降は inject 不要な純粋関数（{@link buildOptimizedVideoUrl}）を返す。
 * これにより、返した関数を computed 内で呼んでも安全。
 *
 * @example
 * const getOptimizedVideoUrl = useOptimizedVideoUrl(); // setup で呼ぶ
 * const url = computed(() => getOptimizedVideoUrl(props.videoUrl, { width: 1280 }));
 */
export const useOptimizedVideoUrl = (): ((originalUrl: string, options?: OptimizeVideoOptions) => string) => {
  const useRuntimeConfig = inject(useRuntimeConfigKey) as UseRuntimeConfig;
  const runtimeConfig = useRuntimeConfig();
  return (originalUrl: string, options: OptimizeVideoOptions = {}): string => buildOptimizedVideoUrl(runtimeConfig.public, originalUrl, options);
};
